import { Component, ViewEncapsulation } from '@angular/core';
import { BreakpointService, ProductFacetNavigationComponent } from '@spartacus/storefront';

@Component({
  selector: 'app-facet-navigation',
  templateUrl: './facet-navigation.component.html',
  styleUrls: ['./facet-navigation.component.scss'],
  standalone: false,
  encapsulation: ViewEncapsulation.None,
})
export class FacetNavigationComponent extends ProductFacetNavigationComponent {
  constructor(protected override breakpointService: BreakpointService,
  ) {
    super(breakpointService);
  }



}
